import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { DAppProvider, ChainId } from "@usedapp/core";

ReactDOM.render(
	<React.StrictMode>
		<DAppProvider
			config={{
				readOnlyChainId: undefined,
				readOnlyUrls: {
					[ChainId.Mainnet]:
						"https://mainnet.infura.io/v3/00fe6a937a904fab939252e7002fd254",
				},
				supportedChains: [ChainId.Mainnet],
			}}
		>
			<App />
		</DAppProvider>
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
